import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin } from "lucide-react";
import MetLogo from "./MetLogo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#003242] text-white/80 pt-12 pb-8 md:pt-14 md:pb-10"
    >
      <div className="met-container">
        {/* Top row: logo + info inline */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          {/* Logo + name */}
          <div className="flex items-center gap-3">
            <MetLogo variant="white" className="h-10 w-10" testid="footer-logo" />
            <div className="leading-none">
              <div className="text-white font-extrabold tracking-tight text-base md:text-lg">
                MET Energie France
              </div>
              <div className="text-[#88d2e7] text-[10px] font-medium tracking-[0.18em] uppercase mt-1">
                {`L'énergie d'entreprendre`}
              </div>
            </div>
          </div>

          {/* Inline info row */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 text-sm font-medium">
            <div className="flex items-center gap-2.5">
              <MapPin size={16} className="text-[#88d2e7] shrink-0" />
              <span data-testid="footer-address">4 Rue de la République, 69001 Lyon</span>
            </div>
            <div className="flex items-center gap-2.5">
              <Mail size={16} className="text-[#88d2e7] shrink-0" />
              <a
                data-testid="footer-email"
                href="mailto:info-metfrance@met.com"
                className="hover:text-white transition-colors"
              >
                info-metfrance@met.com
              </a>
            </div>
            <a
              href="https://www.linkedin.com/company/89194682"
              target="_blank"
              rel="noreferrer noopener"
              data-testid="footer-linkedin"
              aria-label="LinkedIn MET Energie France"
              className="inline-flex items-center gap-2.5 hover:text-white transition-colors"
            >
              <Linkedin size={16} className="text-[#88d2e7] shrink-0" />
              <span>LinkedIn</span>
            </a>
          </div>
        </div>

        {/* Divider + bottom row */}
        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-white/45 font-medium flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} MET Energie France — Tous droits réservés.</span>
          <Link
            to="/politique-de-confidentialite"
            data-testid="footer-privacy-link"
            className="hover:text-white underline-offset-2 hover:underline transition-colors"
          >
            Politique de confidentialité
          </Link>
        </div>
      </div>
    </footer>
  );
}
